import React from 'react';

// "Coming soon" notice for patient-file sections that aren't feature-complete yet.
export default function ComingSoonBanner({ description = 'This section is still being built — what you see here may be incomplete.' }) {
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
        marginBottom: 16, padding: '10px 14px', borderRadius: 10,
        background: 'var(--wi-background-info)', border: '1px solid var(--wi-status-info)',
      }}
      role="note"
    >
      <span
        style={{
          display: 'inline-flex', alignItems: 'center', height: 20, padding: '0 10px',
          borderRadius: 10, fontSize: 10, fontWeight: 700, letterSpacing: '0.04em',
          textTransform: 'uppercase', background: 'var(--wi-status-info-10)', color: 'var(--wi-status-info)',
        }}
      >
        Coming soon
      </span>
      <span className="detail1 text-secondary">{description}</span>
    </div>
  );
}
